import type { ReactNode } from 'react'

import { Component } from 'react'

interface ErrorBoundaryProps {
    fallback: ReactNode
    children: ReactNode
}

interface ErrorBoundaryState {
    failed: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = { failed: false }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { failed: true }
    }

    componentDidCatch(error: unknown) {
        console.error('[configurator] 3D view failed', error)
    }

    render() {
        if (this.state.failed) return this.props.fallback

        return this.props.children
    }
}

export default ErrorBoundary
